export default __webpack_public_path__ + "static/media/CNo.39-0.294451ed.jpg";